var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Sound_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.709804 0 0 0 0 0.223529 0 0 0 0 0.247059 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFF1F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Sound_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.697 10.026V7.08l-10.84 1.114v2.946l10.84-1.114zm2.835-3.067v10.004c.008.087-.476 2.764-.476 2.858 0 1.716-2.931 3.144-4.62 3.144-1.492 0-2.509-1.011-2.509-2.223 0-1.264.954-2.6 2.43-2.814.964-.14 1.754-.14 2.332.061l-.174-4.996h-9.528v8.892c-.112 1.64-2.85 3.177-4.479 3.177C7.016 25.062 6 24.05 6 22.838c0-1.263.953-2.6 2.43-2.814.971-.14 1.766-.14 2.345.066l-.001-11.896c0-.55.39-2.131.943-2.188h14.292c.595-.061-.539.363-.477.953zM8.587 21.087c-.895.13-1.503.982-1.503 1.751 0 .62.532 1.15 1.424 1.15 1.11 0 2.266-1.056 2.266-2.158 0-.785-.62-.971-2.187-.743zm11.927-2.097c-.894.13-1.503.983-1.503 1.752 0 .62.532 1.15 1.424 1.15 1.11 0 2.266-1.056 2.266-2.158 0-.785-.619-.972-2.187-.744z",
    fill: "#3E3E52",
    fillRule: "nonzero"
  })))));
}
export default SvgSound;